import {SkeletonBlock, tabletAndUpLinaria} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const SpotlightSkeleton: React.FC = () => {
  return (
    <SkeletonBlock
      $height={process.env.STACK === 'desktop' ? '75vh' : '45vh'}
    />
  );
};

export const StreamSkeletons: React.FC = () => {
  return (
    <Wrapper>
      {process.env.STACK === 'desktop' && (
        <ProductsGridWithTeaser>
          <SkeletonBlock $width="70%" $height="80vh" />
          <SkeletonBlock $width="30%" $height="80vh" />
        </ProductsGridWithTeaser>
      )}

      {[...Array(6)].map((_, i) => (
        <SkeletonBlock key={i} $height="50vh" />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${tabletAndUpLinaria('gap: 64px;')}
`;

const ProductsGridWithTeaser = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;
